export default __webpack_public_path__ + "static/media/03.95176e62.jpg";